import { Alert, Grid, Typography } from "@mui/material";
import CustomButton from "../../../../components/common/button/CustomButton";
import FormField from "../../../../components/common/FormField";
import { generalInfoFields } from "../settingAllFieldUtils";
import { useEffect, useState } from "react";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  addGeneralInformationAction,
  getGeneralInformationAction,
  setAddGeneralInformationAction,
  updateGeneralInformationAction,
} from "../../../../store/reducers/documentSlice";
import Validation from "../../../../utils/Validation";

interface GeneralInformation {
  driver_wage: string | null;
  porter_wage: string | null;
  packer_wage: string | null;
  // contents_value: string | null;
  [key: string]: string | null; // Allows dynamic key access
}

const GeneralInfoList = () => {
  const dispatch = useDispatch();
  const { genenralInfoData, isGeneralInfoResponse } = useSelector(
    (state: any) => state.document,
  );

  const initialGeneralInfo = {
    driver_wage: null,
    porter_wage: null,
    packer_wage: null,
    // contents_value: null
  };

  const [generalInfoDetails, setGeneralInfoDetails] =
    useState<GeneralInformation>(initialGeneralInfo);

  console.log("generalInfoDetails", generalInfoDetails);

  useEffect(() => {
    dispatch(getGeneralInformationAction());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, []);

  useEffect(() => {
    if (isGeneralInfoResponse) {
      dispatch(getGeneralInformationAction());
      dispatch(setAddGeneralInformationAction(false));
    }
  }, [isGeneralInfoResponse]);

  useEffect(() => {
    if (genenralInfoData) {
      setGeneralInfoDetails(genenralInfoData);
    }
  }, [genenralInfoData]);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    // Update the corresponding question_text for the given question_id (id)
    setGeneralInfoDetails((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;

    // Auto-remove trailing decimal point for float values
    // e.g., "10." becomes "10" when user moves away from field
    if (value && value.endsWith(".")) {
      const trimmedValue = value.slice(0, -1);
      setGeneralInfoDetails((prevState: any) => ({
        ...prevState,
        [id]: trimmedValue,
      }));
    }

    checkValidator(id);
  };

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    driver_wage: generalInfoDetails?.driver_wage,
    porter_wage: generalInfoDetails?.porter_wage,
    packer_wage: generalInfoDetails?.packer_wage,
    // contents_value: generalInfoDetails?.contents_value
  });

  const [isActionCalled, setIsActionCalled] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        const updatedDetails = {
          ...generalInfoDetails,
          driver_wage: generalInfoDetails.driver_wage
            ? Number(generalInfoDetails.driver_wage)
            : null,
          porter_wage: generalInfoDetails.porter_wage
            ? Number(generalInfoDetails.porter_wage)
            : null,
          packer_wage: generalInfoDetails.packer_wage
            ? Number(generalInfoDetails.packer_wage)
            : null,
          // contents_value: generalInfoDetails.contents_value ? Number(generalInfoDetails.contents_value) : null,
        };
        if (genenralInfoData?.id) {
          dispatch(updateGeneralInformationAction(updatedDetails));
        } else {
          dispatch(addGeneralInformationAction(updatedDetails));
        }
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Typography variant="h5" fontWeight={700}>
          General Information{" "}
        </Typography>
        <Alert severity="info" sx={{mt:2}}>
          These are to set the default wage rates, which will be used when generating quotations.
        </Alert>
        <Grid
          container
          spacing={2}
          sx={{
            padding: "10px",
            mt: 1,
            background: "#E5F4F1",
            borderRadius: "5px",
          }}
        >
          <Grid item md={12} xs={12} sx={{ padding: "10px" }}>
            <Grid container spacing={2}>
              {generalInfoFields &&
                generalInfoFields.map((field) => (
                  <FormField
                    key={field.id}
                    // onPaste={(e) => e.preventDefault()}
                    onKeyDown={(event: any) => {
                      // Allow special keys
                      if (
                        event.keyCode === 8 || // backspace
                        event.keyCode === 9 || // tab
                        event.keyCode === 37 || // left arrow
                        event.keyCode === 38 || // up arrow
                        event.keyCode === 39 || // right arrow
                        event.keyCode === 40 || // down arrow
                        event.keyCode === 18 || // alt
                        event.keyCode === 17 || // ctrl
                        event.ctrlKey // ctrl combinations
                      )
                        return event;

                      // For float patterns, allow decimal point even if incomplete
                      const newValue = event.target.value + event.key;
                      const isFloatPattern =
                        field?.patternAllowed?.source?.includes("\\.");

                      // For float inputs: allow intermediate states like "10."
                      if (isFloatPattern) {
                        // Allow digits and one decimal point
                        const floatRegex = /^\d*\.?\d*$/;
                        if (!floatRegex.test(newValue)) {
                          event.preventDefault();
                        }
                      }
                      // For non-float patterns: strict validation
                      else if (
                        field?.patternAllowed &&
                        !field?.patternAllowed.test(event.key)
                      ) {
                        event.preventDefault();
                      } else if (
                        field?.patternAllowed &&
                        !field?.patternAllowed.test(newValue)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    {...{
                      ...field,
                      value: generalInfoDetails
                        ? generalInfoDetails[field?.id]
                        : "",
                      variant: "outlined",
                      minRows: 2,
                      isNonMarginTop: true,
                      onChange: onChangeAction,
                      onBlur: onBlurAction,
                      maxLength: 250,
                      InputProps: {
                        ...(field?.inputProps && field?.inputProps),
                        sx:
                          field?.type === "text" || field?.type === "password"
                            ? { height: "36px" }
                            : {
                                padding: "10px 4px",
                                height: "36px",
                              },
                      },
                      error: error && error[field?.id],
                    }}
                  />
                ))}
            </Grid>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
          >
            <CustomButton
              // disabled={isSubmitDisabled}
              style={{ width: "120px" }}
              title={"Save"}
              onClick={handleSubmit}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default GeneralInfoList;
